<template>
  <div>
    <Subheader :title="project.title" />
    <!-- NRS - 8.28.19 - Commenting out until we figure out monthly donations -->
    <!-- <div class="box__row buttons-container">
      <button
        class="medium-button is-marginless"
        :class="{ 'medium-button--inverted': currentDonationType === 'once' }"
        @click="toggleDonationType('monthly')"
      >
        Give Monthly
      </button>
      <button
        class="medium-button is-marginless inverted"
        :class="{ 'medium-button--inverted': currentDonationType === 'monthly' }"
        @click="toggleDonationType('once')"
      >Give Once</button>
    </div>-->
    <div class="app-content-column">
      <div class="card">
        <h5>Thank you for supporting this milestone.</h5>
        <p>The project will not receive the funds until the milestone is fully funded.</p>
      </div>

      <GoalCard :goal="goal" :project="project" :hide-donate-button="true" />

      <!-- <div class="text"> -->
      <!-- NRS 8.29.19 - Commenting out, not necessary until we do monthly donations -->
      <!-- <div v-if="currentDonationType === 'monthly'" class="text__monthly">
        <p>End Date: {{ endDate }}</p>
        <h6>
          Note: Your monthly donation will recur until END DATE, when this request closes. You can
          manage this and cancel your recurring donations at any time in the settings page.
        </h6>
        <h4>
          Total:
          <span
            >${{ donationAmount ? donationAmount : 0 }} x {{ monthsTillEndDate }} months =</span
          >
          ${{ donationAmount * monthsTillEndDate }}
        </h4>
      </div>-->

      <!-- NRS 8.29.19 - Commenting out, not necessary until we do monthly donations -->
      <!-- <div v-if="currentDonationType === 'once'">
        <h4>Total: ${{ donationAmount ? donationAmount : 0 }}</h4>
      </div>-->
      <!-- </div> -->

      <form class="form" @submit.stop.prevent="selectPayment">
        <div class="amount-container">
          <span>$</span>
          <!-- Only allow full-dollar donations - this is what the back-end supports. -->
          <input
            v-model="donationAmount"
            type="number"
            placeholder="0"
            min="0"
            @keypress="formatDollars($event)"
          />
        </div>

        <div class="button-wrapper is-centered">
          <button
            type="submit"
            class="large-button"
            :disabled="!donationAmount || donationAmount === 0"
          >
            Select Payment Method
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/*global fbq*/
import Subheader from '@/components/Subheader'
import GoalCard from '@/components/GoalCard'
import Project from '@/services/projects'
import Goal from '@/services/goals'

import moment from 'moment'

import { mapGetters } from 'vuex'

export default {
  name: 'GoalDonation',
  components: {
    Subheader,
    GoalCard,
  },
  data() {
    return {
      currentDonationType: 'once',
      donationAmount: null,
      projectId: '',
      goalId: '',
      goal: {},
      project: {},
      endDate: '',
      monthsTillEndDate: null,
    }
  },
  computed: {
    ...mapGetters(['userIsLoggedIn']),
    percentComplete() {
      let percent = (this.goal.receivedFunds / this.goal.targetFunds) * 100
      if (percent >= 100) {
        percent = 100
      }
      return percent
    },
  },
  created() {
    this.projectId = this.$route.params.projectId
    this.goalId = this.$route.params.goalId
    this.refreshData()
  },
  methods: {
    formatDollars(event) {
      // Only allow ASCII characters 0 thru 9
      if (event.charCode < 48 || event.charCode > 57) {
        event.preventDefault()
      }
    },
    refreshData() {
      let projectPromise = Project.api.get(this.projectId).then(data => {
        this.project = data
      })
      let goalPromise = Goal.api.get(this.goalId).then(data => {
        this.goal = data
        this.endDate = moment(this.goal.endDate).format('MMM Do, YYYY')
      })
      Promise.all([projectPromise, goalPromise]).then(() => {
        //monthsTillEndDate = difference in months from now till endDate
        this.monthsTillEndDate = moment(this.goal.endDate).diff(moment(), 'months')
      })
    },
    selectPayment() {
      // TODO: will there be an attribute for user payment methods?

      // Facebook Pixel tracking code
      fbq('track', 'AddPaymentInfo')

      // Route to PaymentSetup if user hasn't set up payment method before
      if (this.userIsLoggedIn) {
        this.$router.push({
          name: 'PaymentSetup',
          params: { goalId: this.goalId, amount: this.donationAmount },
        })
      } else {
        this.$router.push({
          name: 'PaymentSignUp',
          params: { goalId: this.goalId, amount: this.donationAmount },
        })
      }

      // TODO: else route to payment methods list page
    },
    // NRS 8.29.19 - Commenting out, not necessary until we do monthly donations
    // toggleDonationType(clickedType) {
    //   if (this.currentDonationType === 'monthly' && clickedType === 'once') {
    //     this.currentDonationType = 'once'
    //   } else if (this.currentDonationType === 'once' && clickedType === 'monthly') {
    //     this.currentDonationType = 'monthly'
    //   }
    // },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/buttons';
@import '../styles/mixins/cards';
@import '../styles/layout';
@import '../styles/forms';

.card {
  @include card-w-borders();
}

.amount-container {
  display: flex;
  align-items: baseline;

  max-width: 500px;
  margin: auto;

  font-size: 1.5rem;

  input {
    font-size: 1.5rem;
    line-height: 1.5rem;
    margin-left: 0.5rem;
  }
}

// .buttons-container {
//   justify-content: space-around;
// }

// .text {
//   padding: 0 2rem;

//   &__monthly p {
//     margin-bottom: 0;
//   }

//   &__monthly h4 {
//     margin-top: 2rem;
//     font-size: 1.5rem;
//   }

//   &__monthly span {
//     font-size: 1rem;
//   }
// }
</style>
